export { default } from './PopupNewUI';


// WEBPACK FOOTER //
// ./src/components/shared/Popup/index.ts